<template>
   <div>
      <vx-card class="ten-anniversary-banner" no-shadow card-border :card-background="'url(' + bannerBg + '), #000'">
         <div class="banner-inner">
            <div class="vx-row items-center">
               <div class="vx-col lg:w-1/5 w-full text-center lg:text-left">
                  <img :src="logoDiez" alt="redgirasol | Diez Años" class="banner-logo-img">
               </div>
               <div class="vx-col lg:w-3/5 w-full">
                  <div class="banner-text ml-base">
                     <template v-if="!active">
                        <h2 class="banner-title gradient-text">
                           Tus abonos crecen al {{ decimalPercentFormat(lastMonthYield, 2) }}<sup>1</sup> + 4%<sup>2</sup>
                        </h2>
                        <p class="banner-subtitle text-white">
                           Todos los abonos que realices el resto del año crecen con una bonificación de +4% anual
                           adicional hasta el 31 de diciembre de 2026.
                        </p>
                        <p class="banner-disclaimer mb-5">
                           <sup>1</sup>Rendimiento anualizado promedio neto de los últimos 12 meses, antes de
                           impuestos, calculada al mes anterior. No garantiza resultados futuros ni asegura el éxito de la inversión.<br>
                           <sup>2</sup>La bonificación del 4% anual es un incentivo promocional pagado por RedGirasol
                           con recursos propios; no constituye rendimiento de los proyectos ni garantiza su
                           cumplimiento.
                        </p>
                     </template>
                     <template v-else>
                        <h2 class="banner-title gradient-text">
                           Tu inversión crece. Entre más abones, más crecerá
                        </h2>
                        <p class="banner-subtitle text-white">
                           Tu participación en la promoción esta activa.
                        </p>
                     </template>
                  </div>
               </div>
               <div class="vx-col lg:w-1/5 w-full text-center lg:text-right">
                  <div>
                     <vs-button class="mb-6" color="success" type="filled"
                        @click.native="goToPayFundsMain">Abonar</vs-button>
                  </div>
                  <a href="#" class="more-info-link" @click.prevent="infoPopupActive = true">Más información</a>
               </div>
            </div>
         </div>
      </vx-card>

      <!-- POPUP DETALLE PROMOCION 10 AÑOS -->
      <vs-popup class="small-popup header-primary ten-anniversary-info-popup"
         :title="active ? 'Tu bono ya está activo' : 'Un regalo para tí'"
         :active.sync="infoPopupActive">
         <div class="vx-row items-center">
            <div class="vx-col w-full" style="padding: 0 3rem">
               <div class="text-center mb-4 mt-4">
                  <img :src="iconGift" alt="redgirasol | Diez Años" style="width: 70px">
               </div>
               <h3 class="bold mb-4">
                  Tus abonos crecen al {{ decimalPercentFormat(lastMonthYield, 2) }}<sup style="font-size: .5em;">1</sup> + 4%<sup style="font-size: .5em;">2</sup>
               </h3>
               <p class="mb-3">
                  Como parte de la celebración por el <strong>10° aniversario de RedGirasol</strong>, todos los abonos
                  que realices entre agosto y diciembre de 2026 crecerán con un bono de <strong>+4% anual
                     adicional</strong> hasta el 31 de diciembre de 2026.
               </p>
               <p class="mb-4">
                  Entre más pronto abones, ¡más bonificación recibes!
               </p>

               <h4 class="bold mb-2">Cómo funciona:</h4>
               <ul class="info-list mb-4">
                  <li>Para recibir la bonificación, deberás realizar por lo menos 1 abono entre agosto y diciembre de
                     2026.</li>
                  <li>La bonificación aplica sobre todo lo que haga crecer tu cuenta a partir del primer abono realizado
                     durante la vigencia de la promoción, no sobre el total del valor de tu inversión.</li>
                  <li>La verás como una bonificación en tu estado de cuenta del mes siguiente.</li>
                  <li>Esta promoción está limitada a los primeros 25 MDP que se abonen a partir de agosto de 2026.</li>
               </ul>

               <p class="popup-disclaimer mb-4">
                  <sup>1</sup>Rendimiento anualizado promedio neto de los últimos 12 meses, antes de impuestos,
                  calculada al mes anterior. No garantiza resultados futuros ni asegura el éxito de la inversión.<br>
                  <sup>2</sup>La bonificación del 4% anual es un incentivo promocional pagado por RedGirasol con
                  recursos propios; no constituye rendimiento de los proyectos ni garantiza su cumplimiento.
               </p>
               <div class="text-center mt-base">
                  <vs-button class="mb-4" color="dark" type="filled" @click.native="goToPayFundsMain">Abonar</vs-button>
               </div>
               <div class="text-center">
                  <a :href="termsUrl" target="_blank" rel="noopener" class="underline black bold">Consulta Términos y
                     Condiciones</a>
               </div>
            </div>
         </div>


      </vs-popup>
   </div>
</template>

<script>
import PayFundsBtn from "@components/investor/widgets/PayFundsBtn";
import formatHelper from "@mixins/formatHelper";

export default {
   name: "TenAnniversaryPromoBanner",
   components: {
      PayFundsBtn,
   },
   mixins: [formatHelper],
   props: {
      active: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         bannerBg: 'https://cdn.redgirasol.com/investors/home/rg-bg-banner-promo-10.png',
         logoDiez: 'https://cdn.redgirasol.com/investors/home/logotipo-diez.png',
         iconGift: 'https://cdn.redgirasol.com/investors/home/icon-gift.png',
         termsUrl: 'https://soporte.redgirasol.com/support/solutions/articles/48001285299-promoci%C3%B3n-10-a%C3%B1os-redgirasol',
         infoPopupActive: false,
         lastMonthYield: 0
      }
   },
   async beforeMount() {
      this.showLoading(true)
      await this.getSecondaryMarketRgInfo();
      this.showLoading(false)
   },
   methods: {
      async getSecondaryMarketRgInfo() {
         try {
            await axios.get('/api/secondary-market-rg-stats').then((response) => {
               this.lastMonthYield = response.data.last_n_months_yield;
            });
         }
         catch (e) {

         }
      },
      async goToPayFundsMain() {
         this.infoPopupActive = false;
         await this.$router.replace({ name: 'abonarFondos' }).catch(() => { });
      },
   }
}
</script>

<style lang="scss" scoped>
.ten-anniversary-banner {
   // El prop card-background de vx-card inyecta el "background" (imagen + scrim)
   // como estilo inline en la raíz .vx-card (no en .vx-card__body), así que
   // el tamaño/posición deben forzarse aquí con !important para ganarle al inline.
   background-size: cover !important;
   background-position: right center !important;
   background-repeat: no-repeat !important;

   ::v-deep .vx-card__body {
      padding: 1rem;
   }
}

.banner-inner {
   background-color: rgba(0, 0, 0, 0.65);
   border-radius: 0.75rem;
   padding: 0.5rem 3rem;
   margin-top: 0.5rem;
   margin-bottom: 0.5rem;
}

.banner-logo-img {
   width: 100%;
   height: auto;
   max-width: 300px;
}

.banner-text {
   // max-width: 820px;
   margin: 0 auto;
   text-align: center;
}

.banner-title {
   // font-weight: 800;
   font-size: 2.5rem;

   sup {
      font-size: 0.25em;
   }
}

.gradient-text {
   color: #caff00;
}

.banner-subtitle {
   font-size: 1.3rem;
}

.banner-disclaimer {
   color: white;
   font-size: 0.7rem;
   line-height: 1.3;

   sup {
      font-size: 0.9em;
   }
}

.more-info-link {
   color: #fff;
   text-decoration: underline;
   font-size: 1rem;
}

// vx-col no trae separación vertical propia; cuando las columnas se apilan
// (por debajo de md) necesitan su propio espacio entre ellas.
.vx-row>.vx-col {
   margin-bottom: 1.5rem;

   &:last-child {
      margin-bottom: 0;
   }
}

@media (min-width: 768px) {
   .vx-row>.vx-col {
      margin-bottom: 0;
   }
}

// Entre md y xl la columna de texto (50%) es angosta para el título/subtítulo
// a su tamaño de escritorio; se reduce para que no haga wrap feo.
@media (max-width: 1199px) and (min-width: 768px) {
   .banner-title {
      font-size: 2.2rem;
   }

   .banner-subtitle {
      font-size: 1rem;
   }
}

@media (max-width: 767px) {
   .ten-anniversary-banner ::v-deep .vx-card__body {
      padding: 0.75rem;
   }

   .banner-inner {
      padding: 1.75rem;
   }

   .banner-title {
      font-size: 1.6rem;
   }

   .banner-subtitle {
      font-size: 0.9rem;
   }

   .banner-disclaimer {
      font-size: 0.65rem;
   }
}
</style>

<style lang="scss">
.ten-anniversary-info-popup {
   .info-icon-circle {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: #ddf7c0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.25rem;

      .info-icon {
         color: #3aa655;
      }
   }

   .info-list {
      padding-left: 1.5rem;
      list-style: disc;

      li {
         margin-bottom: 0.5rem;
      }
   }

   .popup-disclaimer {
      font-size: 0.75rem;
      line-height: 1.3;
   }

   .popup-divider {
      border: none;
      border-top: 2px solid #1a1a1a;
      margin: 0;
   }

   .popup-actions .vs-button {
      width: 100%;
   }
}
</style>
